module.exports = __webpack_public_path__ + "static/media/example-suppressions-list.0be7da8a.csv";